<template>
    <div class="col-lg-6 col-md-6">
        <a class="post-cards__card" :href="post.link">
            <div class="image">
                <img v-if="post.acf.page_header_image" :src="post.acf.page_header_image.sizes.medium"
                     :alt="post.title" width="343" height="157"/>
                <img v-else-if="post.acf.image" :src="post.acf.image.sizes.medium" :alt="post.title.rendered"
                     width="343" height="157"/>
            </div>
            <div class="content">
                <div class="info info--event">
                    <span class="type" v-for="tax in post.event_type">{{ tax }}</span>
                    <span v-if="post.acf.event_date_start">{{ getEventStartDate(post.acf.event_date_start, post.acf.event_date_end) }}</span>
                    <span class="end" v-if="post.acf.event_date_end">tot {{ getEventEndDate(post.acf.event_date_end) }}</span>
                </div>
                <h3 class="title" v-html="post.title.rendered"></h3>
            </div>
            <div class="arrow">
                <svg class="arrow-icon arrow-icon--left" xmlns="http://www.w3.org/2000/svg"
                     width="15" height="12" fill="none" viewBox="0 0 15 12">
                    <path fill="#F37362" fill-rule="evenodd"
                          d="M14.7695 6.28125 9.84852 11.2155c-.15415.1545-.35665.2319-.55895.2319-.20171 0-.40342-.0768-.55757-.2305-.30868-.3079-.30928-.8077-.00138-1.1164l3.57748-3.58734H.789476C.353488 6.51316 0 6.15967 0 5.72368c0-.43599.353488-.78948.789476-.78948H12.3081L8.73062 1.34702c-.3079-.30869-.3073-.808621.00138-1.116517.30869-.3078956.80862-.3073035 1.11652.001579L14.7695 5.16631c.3073.30809.3073.80665 0 1.11494Z"
                          clip-rule="evenodd"/>
                </svg>
                <svg class="arrow-icon arrow-icon--right" xmlns="http://www.w3.org/2000/svg"
                     width="15" height="12" fill="none" viewBox="0 0 15 12">
                    <path fill="#F37362" fill-rule="evenodd"
                          d="M14.7695 6.28125 9.84852 11.2155c-.15415.1545-.35665.2319-.55895.2319-.20171 0-.40342-.0768-.55757-.2305-.30868-.3079-.30928-.8077-.00138-1.1164l3.57748-3.58734H.789476C.353488 6.51316 0 6.15967 0 5.72368c0-.43599.353488-.78948.789476-.78948H12.3081L8.73062 1.34702c-.3079-.30869-.3073-.808621.00138-1.116517.30869-.3078956.80862-.3073035 1.11652.001579L14.7695 5.16631c.3073.30809.3073.80665 0 1.11494Z"
                          clip-rule="evenodd"/>
                </svg>
            </div>
        </a>
    </div>
</template>


<script>
    import moment from "moment";
    moment.locale('nl');

    export default {
        props: ['post'],

        methods: {

            getEventStartDate(startDate, endDate = null) {
                if (endDate) {
                    return moment(startDate).format('D');
                } else {
                    return moment(startDate).format('LL');
                }
            },
            getEventEndDate(date) {
                return moment(date).format("LL");
            },
        }
    }
</script>